/**
 * PulseAvatar — белый squircle с ЭКГ-зигзагом цвета бренда.
 * Используется как аватар AI-ассистента в чате (header, bubble, typing).
 */

export interface PulseAvatarProps {
  size?: number;
}

export function PulseAvatar({ size = 36 }: PulseAvatarProps) {
  return (
    <span
      aria-hidden
      style={{
        width: size,
        height: size,
        flex: `0 0 ${size}px`,
        borderRadius: 'var(--r-xs)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        boxShadow: 'var(--e1)',
      }}
    >
      <svg
        viewBox="0 0 24 24"
        style={{
          width: size * 0.62,
          height: size * 0.62,
          stroke: 'var(--primary)',
          fill: 'none',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      >
        <polyline points="2,12 6,12 9,5 12,18 15,9 17,12 22,12" />
      </svg>
    </span>
  );
}
